import _ from 'lodash';
import { AutomationSource } from 'api/automation-builder/types';
import { floatUid } from 'utils/uid';
export const automationSlice = {
    updateAllAutomations (state, { payload }) {
        const templateId = state.activeId;
        if (templateId) {
            const activeTemplate = state.data[templateId === null || templateId === void 0 ? void 0 : templateId.toString()];
            activeTemplate.template.automations = payload.automations;
        }
        return state;
    },
    updateAutomationById (state, { payload }) {
        const templateId = state.activeId;
        if (templateId) {
            var _activeTemplate_template;
            const activeTemplate = state.data[templateId === null || templateId === void 0 ? void 0 : templateId.toString()];
            // Not spreading here to pass the null check
            if (activeTemplate === null || activeTemplate === void 0 ? void 0 : (_activeTemplate_template = activeTemplate.template) === null || _activeTemplate_template === void 0 ? void 0 : _activeTemplate_template.automations) {
                const _automationInArray = activeTemplate.template.automations.find((e)=>e.automationId === payload.automationId);
                if (_automationInArray) {
                    const index = activeTemplate.template.automations.indexOf(_automationInArray);
                    activeTemplate.template.automations[index] = _.cloneDeep(payload.automation);
                }
            } else {
                activeTemplate.template.automations = [
                    payload.automation
                ];
            }
        }
        return state;
    },
    toggleEnabledStateForAutomationById (state, { payload }) {
        const templateId = state.activeId;
        if (templateId) {
            var _activeTemplate_template;
            const activeTemplate = state.data[templateId === null || templateId === void 0 ? void 0 : templateId.toString()];
            if (activeTemplate && (activeTemplate === null || activeTemplate === void 0 ? void 0 : (_activeTemplate_template = activeTemplate.template) === null || _activeTemplate_template === void 0 ? void 0 : _activeTemplate_template.automations)) {
                var _activeTemplate_template1;
                const automations = activeTemplate === null || activeTemplate === void 0 ? void 0 : (_activeTemplate_template1 = activeTemplate.template) === null || _activeTemplate_template1 === void 0 ? void 0 : _activeTemplate_template1.automations;
                const automation = automations.find((e)=>e.automationId === payload.automationId);
                if (automation) {
                    const index = automations.indexOf(automation);
                    activeTemplate.template.automations[index].enabled = payload.state;
                }
            }
        }
        return state;
    },
    createAutomationForSource (state, { payload }) {
        const templateId = state.activeId;
        if (templateId) {
            const activeTemplate = state.data[templateId === null || templateId === void 0 ? void 0 : templateId.toString()];
            const newAutomationId = -1 * floatUid();
            const newAutomation = _.set(_.cloneDeep(payload.automation), 'automationId', newAutomationId);
            if (payload.source === AutomationSource.ProjectPhaseTemplate) {
                _.set(newAutomation, 'tags.phaseTemplateInstanceReferenceId', payload.sourceId);
            } else if (payload.source === AutomationSource.TaskTemplate) {
                _.set(newAutomation, 'tags.taskTemplateInstanceReferenceId', payload.sourceId);
            }
            if (activeTemplate.template.automations) {
                activeTemplate.template.automations = activeTemplate.template.automations.concat([
                    newAutomation
                ]);
            } else {
                activeTemplate.template.automations = [
                    newAutomation
                ];
            }
        }
        return state;
    }
};
